import ABCyaPhaser from '@abcya/abcya_phaser';
import AContainer from '../../library/ExtendedObjects/AContainer.js';

export default class IntroWood extends AContainer
{
    constructor(scene)
    {
        super(scene);

        this.wood = this.create(4, 140, 'LogoWood', ABCyaPhaser.Images.LOCALIZATION_ATLAS);
        this.wood.setScale(1.5, 1.5);
        this.wood.alpha = 0;

        this.screw1 = this.create(160, 118, "screwBase");
        this.screw1.setScale(3, 3);
        this.screw1.alpha = 0;

        this.hole1 = this.create(159, 116, "screwHole");
        this.hole1.setScale(3, 3);
        this.hole1.alpha = 0;

        this.screw2 = this.create(-155, 158, "screwBase");
        this.screw2.setScale(3, 3);
        this.screw2.alpha = 0;

        this.hole2 = this.create(-156, 156, "screwHole");
        this.hole2.setScale(3, 3);
        this.hole2.alpha = 0;
    }

    tweenInWood()
    {
        this.scene.addTween(this.wood, 300, {alpha:1}, Phaser.Math.Easing.None);
        this.scene.addTween(this.wood, 750, {scaleX:1, scaleY:1}, Phaser.Math.Easing.Bounce.Out);
    
        this.scene.addDelay(300, ()=>{this.screwIn(this.screw1, this.hole1)});
        this.scene.addDelay(500, ()=>{this.screwIn(this.screw2, this.hole2)});
    }

    screwIn(base, obj)
    {
        this.scene.playSound("intro_screws");

        let randAngle = Phaser.Math.Between(275, 360);
    
        this.scene.addTween(base, 250, {alpha:1}, Phaser.Math.Easing.None);
        this.scene.addTween(base, 500, {scaleX:1, scaleY:1}, Phaser.Math.Easing.Quadratic.Out);
        
        this.scene.addTween(obj, 250, {alpha:1}, Phaser.Math.Easing.None);
        this.scene.addTween(obj, 500, {scaleX:1, scaleY:1}, Phaser.Math.Easing.Quadratic.Out);
        this.scene.addTween(obj, 500, {angle:randAngle}, Phaser.Math.Easing.Quadratic.Out);
    }
}